import Button from 'react-bootstrap/Button'
import Link from 'next/link'

export default function CtaButton ({
  label = 'Get Started',
  subtitle = 'Pick a plan, boost your business',
  variant = 'success',
  // href = '/app/subscription?new=growth'
  href = '/pricing'
}) {
  return (
    <div className={'d-flex flex-column gap-2'}>
      <Link
        href={href}
        legacyBehavior
      >
        <Button
          variant={variant}
          size='lg'
          className={'px-5 py-3 w-100'}
        >
          {label}
        </Button>
      </Link>

      {subtitle && (
        <p className="text-center fs-6 opacity-50 m-0">
          {subtitle}
        </p>
      )}
    </div>
  )
}
